import { Clients } from "../main/partners";
import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { MOTION_OK, revealTrigger, riseFrom } from "../../utils/animations";

export function OurClients() {
  const sectionRef = useRef(null);

  useGSAP(
    () => {
      const mm = gsap.matchMedia();
      mm.add(MOTION_OK, () => {
        riseFrom(".clients-head > *", {
          stagger: 0.15,
          scrollTrigger: revealTrigger(".clients-head"),
        });
      });
      return () => mm.revert();
    },
    { scope: sectionRef }
  );

  return (
    <section ref={sectionRef} className="bg-[#EDF1FF]">
      <div className="container space-y-8">
        <div className="clients-head flex flex-col items-center gap-y-3">
          <h2 className="text-[rgb(2,1,40)] font-extrabold text-[24px] md:text-[32px] text-center">
            Our Clients
          </h2>
          <p className="text-[#020128] text-sm md:text-base text-center max-w-5xl">
            Analytics Intelligence sits at the intersection of three secular
            trends: the enterprise shift to AI-native analytics, the explosive
            growth of agentic applications, and the demand for domain-specific
            AI in quantitative finance.
          </p>
        </div>

        <Clients />
      </div>
    </section>
  );
}
